export enum VisitorType {
  Admin = 'Admin',
  User = 'User',
  AssociationEmployee = 'Employee',
  AssociationAdmin = 'AssociationAdmin',
}
